/** Burbujas de color fijas para posturas en Debate (ex-Muro). El docente no ve hex. */
export interface SerenityColorSwatch {
  id: string;
  label: string;
  hex: string;
}

/** Acentos Serenity / Swiss para iconografía UI */
export const SERENITY_LAVENDER = '#8A7BFA';
export const SERENITY_MINT = '#2DD4BF';

export const SERENITY_STANCE_COLORS: SerenityColorSwatch[] = [
  { id: 'mint', label: 'Menta', hex: '#5eead4' },
  { id: 'coral', label: 'Coral', hex: '#fb7185' },
  { id: 'lavender', label: 'Lavanda', hex: '#c084fc' },
  { id: 'sky', label: 'Celeste', hex: '#38bdf8' },
  { id: 'sun', label: 'Amarillo', hex: '#fbbf24' },
  { id: 'ivory', label: 'Marfil', hex: '#d6d3d1' },
];

export function serenityHexById(id: string): string {
  return SERENITY_STANCE_COLORS.find((s) => s.id === id)?.hex ?? SERENITY_STANCE_COLORS[2].hex;
}

export function serenityIdFromHex(hex: string): string {
  const normalized = hex.toLowerCase();
  return SERENITY_STANCE_COLORS.find((s) => s.hex.toLowerCase() === normalized)?.id ?? 'lavender';
}
